import StatusLabel from "~/components/StatusLabel";
import {renderDate} from "~/utils";
import {Pagination, Table} from "antd";
import CandidateAction from "./CandidateAction";
import SwitchSentEmail from "./SwitchSentEmail";
import SwitchTraining from "./SwitchTraining";

function CandidateTable({items = [], pagination, setItemEdit, onPaginationChange, openModal, toggleSentEmail, toggleTraining}) {

	const columns = [
		{ title: 'Ứng viên', dataIndex: 'fullname', key: "fullname" },
		{ title: 'Gọi Phỏng vấn', dataIndex: 'appointment', key: "appointment", render: (_, item) => (
				<>
					<b>{item?.userCall?.id && item?.userCall?.firstname + ' ' + item?.userCall?.lastname}</b>
					<p style={{"fontSize" : "13px"}}>{renderDate(item?.timeCall)}</p>
				</>
			)},
		{ title: 'Phỏng vấn', dataIndex: 'appointment', key: "appointment", render: (_, item) => (
			<>
				<b>{item?.userInterviewData?.id && item?.userInterviewData?.firstname + ' ' + item?.userInterviewData?.lastname}</b>
				<p style={{"fontSize" : "13px"}}>{renderDate(item?.appointment)}</p>
			</>
		)},
		{ title: 'Liên hệ', dataIndex: 'contact', key: "contact", render: (_, item) => (
			<>
				<p>{item?.phone}</p>
				<p>{item?.email}</p>
			</>
		)},
		{ title: 'Ngày sinh', dataIndex: 'birthday', key: "birthday", render: (_, item) => (renderDate(item?.birthday)) },
		{ title: 'Vị trí', dataIndex: 'apply', key: "apply", width: '120px', render: (_, item) => (<StatusLabel small type={item.apply?.badge}>{item.apply?.label}</StatusLabel>) },
		{ title: 'Trạng thái', dataIndex: 'status', key: "status", width: '150px', render: (_, item) => (
			<StatusLabel small type={item.status.badge}>{item.status.label}</StatusLabel>
		)},
		{ title: 'Đã gửi mail', dataIndex: 'isSentEmail', key: "isSentEmail", width: '150px', render: (_, item) => (<SwitchSentEmail item={item} toggleSentEmail={toggleSentEmail} />)},
		{ title: 'Lên Training', dataIndex: 'isTraining', key: "isTraining", width: '150px', render: (_, item) => (<SwitchTraining item={item} toggleTraining={toggleTraining} />)},

		{ title: '#', dataIndex: 'action', key: "action", width: '50px', render: (_, item) => (
			<CandidateAction item={item} openModal={openModal} setItemEdit={setItemEdit} />
		)},
	];

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:550 }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default CandidateTable;